import { createFileRoute } from '@tanstack/react-router';
import { assertPublicToolsEnabled } from '@/lib/public-tools-feature';
import { TextToAudioDemoPage } from '@/components/astro/new-design-25/SEO/text-to-audio-demo-page';
import { hreflangLinks, seo } from '@/seo/seo';

export const Route = createFileRoute('/_marketing/_seo/text-to-mp3')({
  beforeLoad: assertPublicToolsEnabled,
  head: () => ({
    meta: [
      ...seo({
        title:
          'Text to MP3 Online — Free Text to MP3 Converter with AI Voices | Listening',
        description:
          'Convert text to audio online with natural AI voices. Paste up to 10,000 characters, pick a voice in any of 8 languages, and open a 24-hour read-along link. Free, no sign-up.',
      }),
    ],
    links: [...hreflangLinks('/text-to-mp3')],
  }),
  component: () => (
    <TextToAudioDemoPage
      converterHeading='Text to MP3'
      converterSubtitle='Paste your text and we will turn it into audio'
      conversionLabel='MP3'
      downloadFileBaseName='listening-text-to-mp3'
      faqDescription='Quick answers about the free text to MP3 converter.'
      faqTitle='Text to MP3 FAQ'
      initialFormat='mp3'
    />
  ),
});
